import { render, staticRenderFns } from "./APIReport2.vue?vue&type=template&id=f49c417c&scoped=true"
import script from "./APIReport2.vue?vue&type=script&lang=js"
export * from "./APIReport2.vue?vue&type=script&lang=js"
import style0 from "./APIReport2.vue?vue&type=style&index=0&id=f49c417c&prod&scoped=true&lang=less"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f49c417c",
  null
  
)

export default component.exports